import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import * as signalR from '@aspnet/signalr';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WebinarRunDTO } from './WOWApi.Service';

export const API_BASE_URLRUN = new InjectionToken<string>('API_BASE_URLRUN');
@Injectable({
  providedIn: 'root'
})
export class WebinarRunService {
 private _realTimeData = new BehaviorSubject<WebinarRunDTO | null>(null);
  private baseUrl: string;
  webinarRunDTO:WebinarRunDTO;

  constructor(private _http:HttpClient, @Optional() @Inject(API_BASE_URLRUN) baseUrl?: string ) {
    
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
   }
  hubConnection:signalR.HubConnection;

  startConnection=()=>{
    this.hubConnection = new signalR.HubConnectionBuilder().withUrl(this.baseUrl+"/run",{
      skipNegotiation:true,
      transport: signalR.HttpTransportType.WebSockets
    }).build();

    this.hubConnection.start()
    .then(() => {
       console.log("Success");
    }).catch(
      err => console.log(err)
    );
  }

  public GetData = () => {
    this.hubConnection.on('webinarRunDTO', (data) => {
        this.webinarRunDTO = data;
    });
  }

  setRealTimeData(data:WebinarRunDTO):void
  {
    this._realTimeData.next(data);
  }
  public GetRealTimeData(): Observable<WebinarRunDTO | null>
  {
    return this._realTimeData.asObservable();
  }
  public GetLatestRun(userID:string, runID:string) :Observable<WebinarRunDTO>
  {
     let params:HttpParams = new HttpParams();
     params = params.append("userId", userID);
      params.append("runId", runID);
     return this._http
       .get<WebinarRunDTO>(this.baseUrl + '/GetWebinarRun?webinarGuid=' + encodeURIComponent(runID))
       .pipe(map((raw) => WebinarRunDTO.fromJS(raw)));
  }
}
